/** Odkaz v rámci stránky (#kotva) s plynulým odscrollováním. */

import type { AnchorHTMLAttributes, ReactNode } from 'react';

export function HashLink({
  to,
  children,
  ...rest
}: { to: string; children: ReactNode } & Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'>) {
  return (
    <a
      href={to}
      onClick={(e) => {
        const id = to.replace(/^#/, '');
        const el = document.getElementById(id);
        if (el) {
          e.preventDefault();
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        }
      }}
      {...rest}
    >
      {children}
    </a>
  );
}
